import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import 'rxjs/add/operator/map';
import { AuthHttp } from "angular2-jwt";

@Injectable()
export class CourseService {
  constructor(private http: Http, private authHttp: AuthHttp) { }

  getCoursesbyType(type: number) {
    return this.http.get("/api/courses/bytype/"+type).map(res => res.json());
  }

  getAllCourses() {
    var type = -1;
    return this.http.get("/api/courses/bytype/"+type).map(res => res.json());
  }


  getCourse(id: number) {
    return this.http.get("/api/courses/" + id).map(res => res.json());
  }
  
  getCourseByCourseNR(catid: number, id: number) {
    return this.http.get("/api/courses/coursenr/"+catid+"/" + id).map((res:any)=>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  

  update(course: any) {
    // console.log("course update: " + course);
    return this.authHttp
      .put("/api/courses/" + course.id, course)
      .map(res => res.json());
  }

  create(course: any) {
    // console.log("course create: " + course);
    return this.authHttp.post("/api/courses/", course).map(res => res.json());
  }

  delete(id: number) {
    // console.log("course delete: " + id);
    return this.authHttp.delete("/api/courses/" + id).map(res => res.json());
  }

  getCourseCategories() {
    return this.http.get("/api/courses/categories").map(res => res.json());
  }

  updateComment(id: number, comment: string){
    console.log("in function updateComment");
    var sendComment = {
      key: "comment",
      value: comment
    }
    return this.authHttp.put("/api/courses/comment/"+id,sendComment).map( (res:any)=>{
      console.log("In update comment");
      
      return { 'status': res.status, 'value': res.json() }
    })
  }

  // uploadFile(courseId: number, file: any) {
  //   var formData = new FormData();
  //   formData.append("file", file);
  //   console.log(courseId)
  //   console.log("FormData");
  //   console.log(formData);
  //   return this.http
  //     .post(`/api/courses/upload/${courseId}`, formData)
  //     .map(res => res.json());
  // }

  reloadTrack(id: number) {
    // console.log("Reload Track: " + id);
    return this.authHttp.get(`/api/courses/reloadTrack/${id}`).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  reverseTrack(id: number){
    return this.authHttp.get(`/api/courses/reverse/${id}`).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  // reloadAllTracks(){
  //   return this.authHttp.get('/api/courses/reloadTrack/reloadAll').map(res =>{
  //     return {'status':res.status, 'value':res.json()}
  //   })
  // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/course.service.ts